import { formatDateParam, makeRequest } from "../lib/makeRequest";

export const inventory_details_overall_v3 = (data) =>
  makeRequest("/inventory-details/overall", {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const inventory_details_cluster_v3 = (data) =>
  makeRequest(`/inventory-details/cluster/${data.clusterId}`, {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const inventory_details_area_v3 = (data) =>
  makeRequest(`/inventory-details/area/${data.area_code}`, {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const inventory_details_branch_v3 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", formatDateParam(data.dates.from));
  urlParams.append("to", formatDateParam(data.dates.to));
  return makeRequest(
    `/inventory-details/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
